import { writable } from "svelte/store";

//types
import type { UserNotification } from "@shared/types/UserNotification";

export interface UserNotificationsData {
  unseen: UserNotification[],
  seen: UserNotification[],
  recent: UserNotification[],
  loading: boolean,
  failed: boolean
};

const initialState: UserNotificationsData = {
  unseen: [],
  seen: [],
  recent: [],
  loading: false,
  failed: false
}

export const userNotifications = writable<UserNotificationsData>(initialState);
